// What the air and the cloud layers share by name: the two scale heights of the home planet's air (the exponential air of air.ts), a layer's description, and the share of the star's beam
// two cloud layers let through (the fallback for how much of the sun shows until the probe has been drawn).
//
// The sunlight on a cloud is not here: it is read from the atmosphere's own table at each cloud's height (atmosphereGpu.ts), and the clear sky is the sky-view table (skyView.ts).

export const H_RAY = 8000;
export const H_MIE = 1200;

export interface CloudLayerIn { height: number; cover: number; tau: number; }

/** The beam factor of the two cloud layers for a source at sin(elevation) mu: the server's cloud filter
 *  (world_server._cloud_filter, first value). Used to dim the drawn sun. */
export function beamThroughClouds(mu: number, low: CloudLayerIn, high: CloudLayerIn): number {
  const m = Math.max(mu, 0.08);
  const tbh = (1 - high.cover) + high.cover * Math.exp(-high.tau / m);
  const tbl = (1 - low.cover) + low.cover * Math.exp(-low.tau / m);
  return tbh * tbl;
}
